import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function alphanumericValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && !/^[a-zA-Z0-9]*$/.test(value)) {
      return { alphanumeric: true };
    }
    return null;
  };
}
